module.exports = {
    path: '/technical-dashboard',
    component: () => import("@/modules/technical-dashboard/TechnicalDashboard.vue"),
    meta: { module: "td" },
    children: [
        // NOTE: Initial route is set programmatically based on tab configuration that is pulled from TD endpoint
        // { 
        //     path: '/',
        //     redirect: 'fleet-insights'
        // },
        {
            path: 'fleet-insights',
            name: 'td_fleet_insights',
            component: () => import('@/modules/technical-dashboard/components/FleetInsights')
        },
        {   
            path: 'asset-insights',
            name: 'td_asset_insights',
            component: () => import('@/modules/technical-dashboard/components/AssetInsights'),
        },
        {
            path: 'visualizations',
            name: 'td_visualizations',
            component: () => import('@/modules/technical-dashboard/components/Visualizations')
        },
        {
            path: 'cmms',
            name: 'td_cmms',
            component: () => import('@/modules/technical-dashboard/components/Cmms')
        },
        {
            path: 'eventlog',
            name: 'td_eventlog',
            component: () => import('@/modules/technical-dashboard/components/EventLog')
        },
        {   
            path: 'model-library',
            name: 'td_model_library',
            component: () => import('@/modules/technical-dashboard/components/ModelLibrary'),
        },
        // Note: below routes can be added through tab level congurations
        {   
            path: 'asset-insights-2',
            name: 'td_asset_insights_2',
            component: () => import('@/modules/technical-dashboard/components/AssetInsights'),
        },
        {   
            path: 'asset-insights-3',
            name: 'td_asset_insights_3',
            component: () => import('@/modules/technical-dashboard/components/AssetInsights'),
        },
        {   
            path: 'asset-insights-4',
            name: 'td_asset_insights_4',
            component: () => import('@/modules/technical-dashboard/components/AssetInsights'),
        },
        {   
            path: 'asset-insights-5',
            name: 'td_asset_insights_5',
            component: () => import('@/modules/technical-dashboard/components/AssetInsights'),
        },
    ]
};



// WEBPACK FOOTER //
// ./src/modules/technical-dashboard/router.js